import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotificationModal = ({
  show,
  onClose,
  message,
  translations,
  onClearCoupon,
  urlInactive,
  dynamicLogo,
}) => {
  const navigate = useNavigate();
  if (!show || !message) return null;
  const handleClose = () => {
    onClose();
    if (onClearCoupon) {
      onClearCoupon();
    }
  };

  const getDisplayMessage = () => {
    if (
      message ===
      'The Cyber Risk Report is being compiled and will be sent to your registered email within 30 minutes'
    ) {
      return translations.reportCompilationMessage;
    }
    if (message === 'Assessment started!') {
      return translations.assessmentStarted;
    }
    if (message === translations.anErrorOccurred) {
      return translations.anErrorOccurred;
    }
    if (message === 'Failed to initialize payment') {
      return translations.failedToInitializePayment;
    }
    if (message === translations.emailVerifiedSuccess) {
      return translations.emailVerifiedSuccess;
    }
    if (
      message ===
      'Invalid or expired verification token. Please request a new one.'
    ) {
      return translations.invalidOrExpiredVerificationToken;
    }
    if (message === translations.verificationEmailSent) {
      return translations.verificationEmailSent;
    }
    return message;
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
      }}
    >
      <div
        style={{
          background: 'white',
          borderRadius: '12px',
          width: '100%',
          maxWidth: '500px',
          padding: '16px 20px',
          boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
          textAlign: 'center',
        }}
      >
        <div
          className="p-0"
          style={{
            marginBottom: '8px',
            filter: 'drop-shadow(0 0 8px rgba(0,0,0,0.3))',
          }}
        >
          <img
            src={
              dynamicLogo ||
              'https://washi.s3.amazonaws.com/RiskReport360.png'
            }
            alt="Almata Logo"
            className="logo_main"
          />
        </div>
        <h4 className="notification_heading">{translations.notification}</h4>
        <div className="notification_message">{getDisplayMessage()}</div>
        {!urlInactive && (
          <button
            className="btn btn-primary"
            onClick={handleClose}
            style={{
              padding: '10px 20px',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '700',
              background: 'rgb(37, 99, 235)',
              border: 'none',
            }}
          >
            {translations.close}
          </button>
        )}
      </div>
    </div>
  );
};

export default NotificationModal;
